/**
 * A labelled row under the combined model picker's list: Reasoning, Speed or
 * Access, then its segments.
 *
 * @module components/chat/ModelEffortSettingRow
 */
import type { ReactNode } from "react";

export function ModelEffortSettingRow({ label, children }: { readonly label: string; readonly children: ReactNode }) {
  return (
    <div data-model-effort-row={label.toLowerCase()} className="grid h-9 grid-cols-[6rem_minmax(0,1fr)] items-center gap-2 ps-2 pe-0.5">
      <span className="text-[13px] text-muted-foreground">{label}</span>
      <div className="flex min-w-0 justify-start">{children}</div>
    </div>
  );
}
